import { NgModule, Component, Input, Inject,ChangeDetectionStrategy, PLATFORM_ID, OnChanges, SimpleChanges, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { StateInteractionService } from 'angular-engine/engine/service/dynamic/state.interaction.service';
import {Observable} from 'rxjs';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import 'rxjs/add/observable/of';
@Component({
    selector: 'percent-played',
    templateUrl: 'percent-played.template.html',
    styleUrls: ['./percent-played.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PercentPlayed {
    @Input() item: any;
    @Input() stats : any;
    @Input() timestamp;
    @Input() percentPlayed;
    @Input() durationWatched;
    @Input() inVideo :boolean = false;
    @Input() active : boolean = true;
    private isPlaying:boolean = false;
    private isServer : boolean;
    private _videoId : string;
    constructor (
        protected coreEffects: CoreEffects,
        protected cd: ChangeDetectorRef,
        protected stateInteraction: StateInteractionService,
        protected interactions : EventInteraction,
        @Inject(PLATFORM_ID) platformId: string
    ){
        this.isServer = isPlatformServer(platformId);
    }


    ngOnChanges( changes ){
        if( changes.durationWatched ) {
            
        }
        if (changes.percentPlayed ){
            if( this.percentPlayed ){
                
            }
        }
        if( changes.item && changes.item.currentValue ){    
        }
    }

    private subscribeToVideoStats(){
        if( !this.isServer && this.item.obj_type != "mock"  && this.videoId){
            this.stats = this.stateInteraction
            .getVideoStats(this.videoId);
        }
    }

    public get videoId () :string {
        let id : string =  this.item.unique_id;
        return id;
    }

    public startVideo(timestamp: number){
        this.interactions.next( {key: 'start-video', message: timestamp});
        this.active = false;
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/percent-played/percent-played.component.ts